import { IContactIOS } from "../types/contacts"

export const СONTACTS: IContactIOS[] = [
  {
    identifier: "AB12345",
    givenName: "Антон",
    familyName: "",
    organizationName: "ООО Фейковая компания",
    phoneNumbers: [
      {
        label: "Мобильный",
        value: "+7 (926) 251-33-05",
      },
    ],
    emailAddresses: [
      {
        label: "Рабочий",
        value: "anton@example.com",
      },
    ],
  },
  {
    identifier: "CD67890",
    givenName: "Андрей Работа",
    familyName: "",
    organizationName: "ООО Рабочая компания",
    phoneNumbers: [
      {
        label: "Мобильный",
        value: "+7 (901) 350-20-06",
      },
    ],
    emailAddresses: [
      {
        label: "Рабочий",
        value: "andrey@example.com",
      },
    ],
  },
  {
    identifier: "EF12345",
    givenName: "Анастасия",
    familyName: "",
    organizationName: "ООО Фейковая компания",
    phoneNumbers: [
      {
        label: "Мобильный",
        value: "+7 (901) 999-45-55",
      },
    ],
    emailAddresses: [
      {
        label: "Рабочий",
        value: "anastasia@example.com",
      },
    ],
  },
  {
    identifier: "GH67890",
    givenName: "Светлана Барковская",
    familyName: "",
    organizationName: "ООО Фейковая компания",
    phoneNumbers: [
      {
        label: "Мобильный",
        value: "+7 (977) 257-03-05",
      },
    ],
    emailAddresses: [
      {
        label: "Рабочий",
        value: "svetlana@example.com",
      },
    ],
  },
  {
    identifier: "IJ12345",
    givenName: "Александр Белов",
    familyName: "",
    organizationName: "ООО Фейковая компания",
    phoneNumbers: [
      {
        label: "Мобильный",
        value: "+7 (977) 250-03-05",
      },
    ],
    emailAddresses: [
      {
        label: "Рабочий",
        value: "alexander@example.com",
      },
    ],
  },
  {
    identifier: "KL67890",
    givenName: "Ольга Белоглазова",
    familyName: "",
    organizationName: "ООО Фейковая компания",
    phoneNumbers: [
      {
        label: "Мобильный",
        value: "+7 (977) 250-03-05",
      },
    ],
    emailAddresses: [
      {
        label: "Рабочий",
        value: "olga@example.com",
      },
    ],
  },
  {
    identifier: "MN12345",
    givenName: "Екатерина Брагина",
    familyName: "",
    organizationName: "ООО Рабочая компания",
    phoneNumbers: [
      {
        label: "Мобильный",
        value: "+7 (901) 350-20-06",
      },
    ],
    emailAddresses: [
      {
        label: "Рабочий",
        value: "ekaterina@example.com",
      },
    ],
  },
  {
    identifier: "OP67890",
    givenName: "Брат",
    familyName: "",
    organizationName: "ООО Фейковая компания",
    phoneNumbers: [
      {
        label: "Мобильный",
        value: "+7 (977) 250-03-05",
      },
    ],
    emailAddresses: [
      {
        label: "Рабочий",
        value: "brother@example.com",
      },
    ],
  },
]
export const LAST_USED_CONTACTS: IContactIOS[] = [
  {
    identifier: "CD67890",
    givenName: "Андрей Работа",
    familyName: "",
    organizationName: "ООО Рабочая компания",
    phoneNumbers: [
      {
        label: "Мобильный",
        value: "+7 (901) 350-20-06",
      },
    ],
    emailAddresses: [
      {
        label: "Рабочий",
        value: "andrey@example.com",
      },
    ],
  },
  {
    identifier: "MN12345",
    givenName: "Екатерина Брагина",
    familyName: "",
    organizationName: "ООО Рабочая компания",
    phoneNumbers: [
      {
        label: "Мобильный",
        value: "+7 (901) 350-20-06",
      },
    ],
    emailAddresses: [
      {
        label: "Рабочий",
        value: "ekaterina@example.com",
      },
    ],
  },
  {
    identifier: "OP67890",
    givenName: "Брат",
    familyName: "",
    organizationName: "ООО Фейковая компания",
    phoneNumbers: [
      {
        label: "Мобильный",
        value: "+7 (977) 250-03-05",
      },
    ],
    emailAddresses: [
      {
        label: "Рабочий",
        value: "brother@example.com",
      },
    ],
  },
]
